import { environment } from '@masar/env/environment';
import { ConvexClient } from 'convex/browser';
import { from, Observable } from 'rxjs';

export class ConvexService {
    private readonly client: ConvexClient = new ConvexClient(
        environment.convexUrl
    );

    public query<Query extends Parameters<typeof this.client.query>[0]>(
        query: Query,
        args: Query['_args']
    ): Observable<Query['_returnType']> {
        return new Observable(subscriber => {
            const unsubscribe = this.client.onUpdate(query, args, result => {
                if (result !== undefined) {
                    subscriber.next(result);
                }
            });

            return () => unsubscribe();
        });
    }

    public mutation<
        Mutation extends Parameters<typeof this.client.mutation>[0],
    >(
        mutation: Mutation,
        args: Mutation['_args']
    ): Observable<Mutation['_returnType']> {
        return from(this.client.mutation(mutation, args));
    }

    public action<Action extends Parameters<typeof this.client.action>[0]>(
        action: Action,
        args: Action['_args']
    ): Observable<Action['_returnType']> {
        return from(this.client.action(action, args));
    }
}
